import { request } from "../utils/request.js"

export const purchaseOrder_exportForManage = (pojo, args) => request({
    url: 'purchaseOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageForManage = (pojo, args) => request({
    url: 'purchaseOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_getSumDataForManage = (pojo, args) => request({
    url: 'purchaseOrder/getSumDataForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: false,
    ...args
})

export const purchaseOrder_addNew = (pojo, args) => request({
    url: 'purchaseOrder/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_update = (pojo, args) => request({
    url: 'purchaseOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_deleteById = (id, args) => request({
    url: 'purchaseOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_findById = (id, args) => request({
    url: 'purchaseOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findHeadVoById = (id, args) => request({
    url: 'purchaseOrder/findHeadVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findVoById = (id, args) => request({
    url: 'purchaseOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


export const purchaseOrder_commodityPurchaseReport_sum = (pojo, args) => request({
    url: 'purchaseOrder/commodityPurchaseReport/sum',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_commodityPurchaseReport_item = (pojo, args) => request({
    url: 'purchaseOrder/commodityPurchaseReport/item',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_commodityPurchaseReport_export = (pojo, args) => request({
    url: 'purchaseOrder/commodityPurchaseReport/export',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/purchaseOrder.js